// extracted by mini-css-extract-plugin
export default {"text__gray":"not_found_text__gray__s1XuW","link":"not_found_link__2g53q"};